import { useQuery } from '@tanstack/react-query';

import { Query } from './api';

export const useUser = () => {
  return useQuery({
    queryKey: ['users', 'me'],
    queryFn: async () => {
      console.log('🔐 Fetching real user data from API...');
      try {
        const result = await new Query('users/me').run();
        console.log('✅ User data fetched successfully:', result);
        return result; // Return the Model object directly, not result.getData()
      } catch (error) {
        console.error('❌ Failed to fetch user data:', error);
        // If authentication fails, return null so RequireAuth can redirect to login
        throw error;
      }
    },
    staleTime: 300000,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true, // Enable fetching on mount to detect existing sessions
  });
};
